import React, { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { setToken, getCurrentUser } from '../../../redux/slices/authSlice';
import { showToast } from '../../../redux/slices/toastSlice';
import i18n from '../../../i18n';
import { getCurrentPosition } from '../../../utils/workLocation';

const LoginSuccess = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  useEffect(() => {
    const token = searchParams.get('token');
    const idToken = searchParams.get('id_token');

    if (token) {
      localStorage.setItem('token', token);
      
      if (idToken) {
        localStorage.setItem('keycloak_id_token', idToken);
      }

      dispatch(setToken(token));

      dispatch(getCurrentUser())
        .unwrap()
        .then(() => {
          dispatch(showToast({ message: i18n.t("auth.sso_login_success"), type: "success" }));
          getCurrentPosition();
          navigate('/'); 
        })
        .catch((error) => {
          dispatch(showToast({ message: error?.detail || i18n.t("auth.sso_login_failed"), type: "error" }));
        })
    } else {
      navigate('/login');
    }
  }, [searchParams, navigate, dispatch]);

  return (
    <div className="flex items-center justify-center h-screen">
      <p>{i18n.t("pages.LoginSuccess.authenticating")}</p>
    </div>
  );
};

export default LoginSuccess;